import dynamic from 'next/dynamic'
import Head from 'next/head'
import Header from '../../components/Header';
import CTA from '../../components/CTA';
import Image from "next/legacy/image";
import YoastSEO from '../../components/YoastSEO';

import { client } from '../../lib/apollo';
import { Tooltip as ReactTooltip } from "react-tooltip";
import { GET_HEADER_OPTIONS, GET_FOOTER_OPTIONS, GET_NEWS_DATA, GET_404_DATA } from '../../queries/queries';

import { formatPostDate } from "../../utilities/dateFormat"
import Script from 'next/script'
import { RouteChangeListener } from '../../components/OptinMonsterEmbed';

const DynamicFooter = dynamic(() => import('../../components/Footer'))

export default function NewsPage({ pageData }) {
  const headerData = pageData?.headerData;
  const footerData = pageData?.footerData;

  const post = pageData?.post;
  let postTitle = pageData?.post?.title;

  const { convert } = require('html-to-text');
  postTitle = convert(postTitle);

  const cta = pageData?.footerData?.data?.siteOptions?.siteOptions?.cta[0];
  const nextPost = pageData?.nextPost;

  let seoData = pageData?.post?.seo;

  let caption = '';

  if(post?.featuredImage?.node?.caption){
      caption = post?.featuredImage?.node?.caption.toString().replace(/<[^>]*>?/gm, '');
  }

  if(!seoData){
    seoData = {
      title: '404'
    };
  }

  const errorContent = pageData?.noPageData?.data?.siteOptions?.siteOptions?.errorContent;

  return (
      <div>
        <Script defer={true}>
          {`(function (w, d, s, l, i) {
                    w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
                    var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
                    j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
                })(window, document, 'script', 'dataLayer', 'GTM-KJ842L9');`}
        </Script>
        <Script defer={true}>
          {`!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','1908777585816939');fbq('track','PageView');
        `}
        </Script>
        <YoastSEO
          page={seoData}
          MetaRenderElement={Head}
          meta={<>
            <meta name="MobileOptimized" content="width" />
            <meta name="HandheldFriendly" content="True"/>
            <meta name="viewport" content="width=device-width, initial-scale=1.0, minimum-scale=1.0" />
            <title>Natural Lands</title>
            <link rel="icon" href="/assets/favicon/favicon.ico"></link>
          </>}
        ></YoastSEO>
        <Header header={headerData}></Header>
        <main>
          <div id="content" role="main">
            {
              post && (
                <>
                    <div id="single-news-header-container" className={`${post.featuredImage ? 'container-fluid' : 'container-fluid no-image'}`}>
                        <div className='container large-container'>
                            <h1 dangerouslySetInnerHTML={{__html: post.title}} className='news-title'></h1>
                            <p>{formatPostDate(post.date)}</p>
                        </div>
                    </div>
                    <div id="single-news-content" className={`${post.featuredImage ? 'container large-container' : 'container large-container no-image'}`}>
                        {
                          post.featuredImage && (
                            <div id="single-news-image">
                                <Image
                                    src={`${post.featuredImage?.node?.sourceUrl}`}
                                    srcSet={post.featuredImage?.node?.srcSet}
                                    sizes={post.featuredImage?.node?.sizes}
                                    height={860}
                                    quality={100}
                                    width={625}
                                    alt={post.featuredImage?.node?.altText}
                                    title={post.featuredImage?.node?.title}
                                />
                                {
                                  post?.featuredImage?.node?.caption && (
                                    <div id="single-news-image-caption">
                                        <a data-tooltip-id="fmv-tooltip" data-tooltip-content={`${caption}`}>
                                          <img width={24} height={24} src="/assets/images/icon-photo-credit.svg" alt="Tooltip" />
                                      </a>
                                      <ReactTooltip openOnClick={true} id="fmv-tooltip"></ReactTooltip>
                                    </div>
                                  )
                                }
                            </div>
                          )
                        }
                        
                        {
                          post?.featuredImage?.node?.description && (
                            <div id="single-news-description" dangerouslySetInnerHTML={{__html: post.featuredImage.node.description}}></div>
                          )
                        }
                        <div dangerouslySetInnerHTML={{__html: post.content}}></div>
                    </div>
                </>
              )
            }
            {
              !post && (
                  <div id="error-container" className='container'>
                    <div dangerouslySetInnerHTML={{__html: errorContent}}></div>
                  </div>
              )
            }
            {
                post && nextPost && (
                    <div id="next-news-post-container" className='container'>
                        <h2>next post</h2>
                        <div>
                            <div>
                                <Image
                                    src={`${nextPost.image}`}
                                    height={625}
                                    quality={100}
                                    width={860}
                                    alt={nextPost.imageAlt}
                                    title={nextPost.imageAlt}
                                />
                            </div>
                            <div>
                                <h4>{nextPost.title}</h4>
                                <p>{nextPost.date}</p>
                                {
                                    nextPost.searchExcerpt && (
                                        <div className='excerpt' dangerouslySetInnerHTML={{__html: nextPost.searchExcerpt}}></div>
                                    )
                                }
                                {
                                    !nextPost.searchExcerpt && nextPost.excerpt && (
                                      <p className='excerpt' dangerouslySetInnerHTML={{__html: nextPost.excerpt}}></p>
                                  )
                                }
                                <a href={`${nextPost.link}`} className='button red'>
                                    continue reading
                                </a>
                            </div>
                        </div>
                    </div>
                )
            }
            <CTA
              cta={cta}
            ></CTA>
          </div>
          <Script defer={true}>
            {`(function(d,u,ac){var s=d.createElement('script');s.type='text/javascript';s.src='https://a.omappapi.com/app/js/api.min.js';s.async=true;s.dataset.user=u;s.dataset.account=ac;d.getElementsByTagName('head')[0].appendChild(s);})(document,32897,23154);
    <!-- / OptinMonster -->`}
            </Script>
            <RouteChangeListener/>
        </main>
        <DynamicFooter footer={footerData}></DynamicFooter>
      </div>
  )
}

export async function getStaticProps({ params }){
  const slug = params.uri;

  const response = await client.query({
    query: GET_NEWS_DATA,
    variables: { slug: slug }
  });

  const post = response?.data?.postBy; 
  const nextPost = await fetch(`${process.env.NEXT_PUBLIC_WORDPRESS_API_URL}/wp-json/naturallands/v1/blog/next?postId=${post?.databaseId}`);
  const nextPostData = await nextPost.json();

  const footerData = await client.query({
    query: GET_FOOTER_OPTIONS
  });

  const headerData = await client.query({
    query: GET_HEADER_OPTIONS
  });

  const noPageData = await client.query({
    query: GET_404_DATA
  });

  if(!post){
      return {
        redirect: {
          destination: '/news',
          permanent: false,
          // statusCode: 301
        },
      }
  }

  return {
    props: {
      pageData: {
        footerData: footerData,
        headerData: headerData,
        noPageData: noPageData,
        post: post,
        nextPost: JSON.parse(nextPostData)
      }
    },
    revalidate: 45,
  }
}

export async function getStaticPaths(){
    const paths = []
    return {
        paths,
        fallback: 'blocking'
    }
}